import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { setDate } from '../../actions/dateFilter';

function DateRangePicker({onChange , onClear, dateProps, filters}){


    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;
    const dates = dateProps.dateValue
    useEffect(() => {

        try {

            if(dates.length > 0){
                setDateRange([new Date(dates[0]), new Date(dates[1])])
            }
            if(onClear){
                //set null if filter is cleared
                setDateRange(['', ''])
            }
        } catch(e) {

            console.log('setDateRange Error: ', e)
        }
    },[onClear])
    //console.log('DATES UPDATE filtering',filters)
    return (
        <div style={{zIndex: "2", paddingRight: "5px"}} 
            data-toggle="tooltip"
            data-placement="top"
            >
        <DatePicker
            className="form-control datepickerinput"
            selectsRange={true}
            startDate={ startDate}
            endDate={endDate}
            onChange={(update) => {
                try {

                    console.log('DATES UPDATE',update)
                    onChange(update,filters)
                    setDateRange(update);
                } catch(e) {

                    console.log('setDateRange Error: ', e)
                }
            }}
            placeholderText="Search date"
            // isClearable={true}
        />
        </div>
    );

}


export default DateRangePicker;


// WEBPACK FOOTER //
// ./src/components/filters/DateRangePicker.js